      <div class="main">
        <div class="para">
          <div class="decor" [innerHTML]="text" appBlockCopyPaste></div>      
        </div>
     </div>

